import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero/Hero';
import Features from '../../components/Features/Features';
import VideoSection from '../../components/VideoSection/VideoSection';
import Screenshots from '../../components/Screenshots/Screenshots';
import Footer from '../../components/Footer/Footer';
// import Outsourcing from '../../components/Outsourcing/Outsourcing';
import Pricing from '../../components/Pricing/Pricing';
import SetupDownload from '../../components/SetupDownload/SetupDownload';
import fnc from '../../components/mymod/commFunction';
import './Home.scss';

const VIEW_COUNT_INCREASE_INTERVAL_MS = 60 * 60 * 1000;

const Home = () => {
  useEffect(() => {
    const storageKey = 'homeViewCount_lastIncreaseAt';
    const now = Date.now();
    const lastIncreaseAt = Number(sessionStorage.getItem(storageKey) || 0);
    const shouldIncrease = now - lastIncreaseAt > VIEW_COUNT_INCREASE_INTERVAL_MS;

    if (shouldIncrease) {
      sessionStorage.setItem(storageKey, String(now));
      fnc.sendAxios('/homePageRoutes/increaseViewCount', { pageKey: 'home' }, () => {});
      return;
    }

    fnc.sendAxios('/homePageRoutes/selectViewCount', { pageKey: 'home' }, () => {});
  }, []);

  return (
    <main className="home">
      <Helmet>
        <title>매쓰테일러 - PDF HWP 변환 · 나만의 문제은행 구축 · 수학 AI</title>
        <meta name="description" content="PDF를 HWP로 변환하고 나만의 문제은행을 구축하세요. 단원관리, 문제출제, 시험지 저장, HWP·PDF 프린트와 수학 AI 기능을 제공하는 매쓰테일러입니다." />
        <meta name="keywords" content="매쓰테일러, 나만의 문제은행 구축, HWP 문제은행, 수학 문제은행, 문제은행 프로그램, 단원관리, 문제출제, 시험지 저장, HWP PDF 프린트, PDF HWP 변환, 수학 pdf hwp변환, 수식 pdf hwp변환, 낙서 pdf hwp변환, 낙서 수학기출문제 hwp변환, 수식OCR, 수학OCR, 수학수식OCR, 한글수식OCR, OCR파일, HWP파일수식, 수학문제타이핑, 수학타이핑, 수학문제집타이핑, 수식타이핑, 수식문제타이핑, 수학 문제풀이, 변형문제, 유사문제, 수학 이미지 그리기, 수학 도형 이미지, 수학 문제 변형, 수학 도형 작도, 수학 AI, 맞춤형 수학 학습" />
        <meta property="og:title" content="매쓰테일러 - PDF HWP 변환 · 나만의 문제은행 구축" />
        <meta property="og:description" content="PDF를 HWP로 변환하고 나만의 문제은행을 구축하세요. 단원관리부터 문제출제, 시험지 저장과 HWP·PDF 프린트까지 지원합니다." />
        <meta property="og:url" content="https://xn--vl2b19ao0ssqc39r.kr/" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '매쓰테일러',
            url: 'https://xn--vl2b19ao0ssqc39r.kr/',
            description: 'PDF HWP 변환과 나만의 문제은행 구축, 단원관리, 문제출제, 시험지 저장 및 프린트를 지원하는 수학 교육 플랫폼'
          })}
        </script>
      </Helmet>
      <Hero />
      <Features />
      <VideoSection />
      <Screenshots />
      <Pricing />
      <SetupDownload />
      {/* <Outsourcing /> */}
      <Footer />
    </main>
  );
};

export default Home;

